import ApiRequest from "./lib/api-request";
import {ApiRequestOptions} from "./@type";
import {RequestType} from "../data/types";
import ajaxRequestV2 from "./lib/ajax-request-v2";

export default class ApiAutomationsRequest extends ApiRequest {


    static _request(context:any, type:RequestType, endpoint:string, payload:any, options?:ApiRequestOptions) {

        options = ApiRequest._normalizeOptions(options);

        payload = ApiRequest._normalizePayload(payload, {
            'timezone'  : true,
            'sessionId' : true,
            'companyId' : true
        })

        const headers = ApiRequest._normalizeHeaders()

        const params = {
            context : context,
            type    : type,
            url     : ApiRequest._normalizeUrl(gdConfig.apiAutomations, endpoint),
            endpoint: endpoint,
            payload : payload,
            headers : headers
        }

        return ajaxRequestV2(params, options)
    }

}
